import type { UserAcceptResource } from 'entities/document/model';
import { signMethodCalculate } from 'features/document/workflow/helpers/sign-method-calculate';
import type { WorkflowDesignerContext } from 'features/workflow/designer/share';
import type { UserData } from 'shared/user';
import type { WorkflowElement } from 'shared/workflow';
import { v4 as uuid } from 'uuid';

export const convertUserToParticipantUser =
  (type: 'sign' | 'accept') =>
  (
    user: WorkflowElement<'user', UserData>,
    context?: WorkflowDesignerContext,
  ): UserAcceptResource => {
    const id = uuid();

    const { document } = context || {};

    const signMethod = signMethodCalculate(type, document);

    return {
      id,
      type: 'participant-user',
      parameters: {
        signMethod,
        user: user.parameters,
      } as any,
    };
  };
